<template>
	<v-dialog v-model="showPopup" persistent scrollable :max-width="$vuetify.breakpoint.mobile ? '90%' : '75%'">
		<v-card v-if="!inviteSent" class="justify-center text-center card-rounded pb-5" min-height="90vh">
			<v-card-title
				class="pa-2 white--text justify-center text-center secondary"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-row>
					<v-spacer></v-spacer>
					<span class="headline white--text">Invite a Locum</span>
					<v-spacer></v-spacer>
				</v-row>
				<v-btn icon color="white" @click="toggleInviteLocum">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="text-center justify-center center-container" min-height="90vh">
				<v-container class="card-rounded pb-2">
					<v-row justify="center" class="mb-4">
						<span class="text-h5 font-weight-bold">Please enter email of invitee</span>
					</v-row>
					<v-row justify="center">
						<v-col cols="12" md="6">
							<v-text-field v-model="textValue" label="Enter Email" outlined :rules="[rules.email]" required></v-text-field>
						</v-col>
					</v-row>
					<v-row justify="center">
						<v-btn class="mb-2" min-width="150" min-height="50" depressed color="secondary" :loading="isLoading" @click="sendInvite">Invite</v-btn>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>

		<v-card v-if="inviteSent" class="justify-center text-center card-rounded pb-5" min-height="90vh">
			<v-card-title
				class="pa-2 white--text justify-center text-center secondary"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-row>
					<v-spacer></v-spacer>
					<span class="headline white--text">Invite a Locum</span>
					<v-spacer></v-spacer>
				</v-row>
				<v-btn icon color="white" @click="toggleInviteLocum">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="text-center justify-center center-container" min-height="90vh">
				<v-container class="card-rounded pb-2">
					<v-row justify="center" class="mb-4">
						<v-img :src="require('../../../../assets/icons/done.svg')" max-height="150px" max-width="150px" class="mb-1"></v-img>
					</v-row>
					<v-row justify="center" class="mb-4">
						<span class="text-h5 font-weight-bold mb-4" style="font-size: 24px">Invite sent!</span>
					</v-row>
					<v-row justify="center">
						<v-btn class="mb-2" min-width="150" min-height="50" depressed color="secondary" :loading="isLoading" @click="backToInvite">Continue</v-btn>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';

export default {
	name: 'InvitePopUp',
	props: {},
	data: () => ({
		showPopup: false,
		textValue: '',
		isLoading: false,
		inviteSent: false,
		rules: {
			email: value => /.+@.+\..+/.test(value) || 'Please enter a valid email address',
		},
	}),
	async mounted() {
		bus.$on('show-invite-popup', () => {
			this.showPopup = !this.showPopup;
		});
	},
	methods: {
		...mapActions('invite', ['InviteNewUser']),
		toggleInviteLocum() {
			bus.$emit('show-invite-popup');
			this.dismissFeaturedLocums();
		},
		checkEmail() {
			return /.+@.+\..+/.test(this.textValue);
		},
		async sendInvite() {
			if (!this.checkEmail()) return;
			this.loadingInvite = true;
			this.inviteSent = true;

			const data = {
				email: this.textValue,
			};
			try {
				this.isLoading = true;
				await this.InviteNewUser({ data });
			} catch (err) {
				console.error(err);
			}
			this.isLoading = false;
			this.textValue = '';

			this.loadingInvite = false;
		},
		backToInvite() {
			this.inviteSent = false;
		},
	},
};
</script>

<style scoped>
.center-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>
